<template>
  <v-app id="app" class="background">
    <div>
      <!--DRAWER-->
      <drawer-enterprise></drawer-enterprise>
      <!--MENU-->
      <menu-top></menu-top>
      <v-content class="background">
        <v-fade-transition mode="out-in">
          <router-view />
          <resume-enterprise></resume-enterprise>
        </v-fade-transition>
      </v-content>
    </div>
    <alert></alert>
    <spin></spin>
    <!--      <open-security></open-security>-->
    <!--      <open-wallet></open-wallet>-->
    <!--      <alert></alert>-->
    <!--      <open-pin></open-pin>-->
    <!--      <spin></spin>-->
    <!--      <bank-account></bank-account>-->
    <!--      <open-transfer-wallet></open-transfer-wallet>-->
    <open-security></open-security>
    <open-charge-wallet-enterprise></open-charge-wallet-enterprise>
    <open-pin></open-pin>
    <bank-account-enterprise></bank-account-enterprise>
    <open-transfer-wallet-enterprise></open-transfer-wallet-enterprise>
    <message-suport-client></message-suport-client>
  </v-app>
</template>

<script>
import MenuTop from "../components/dashboard/Menu";
import Alert from "../components/tools/Alert";
import Spin from "../components/tools/Spin";
import DrawerEnterprise from "../components/dashboard/enterprise/DrawerEnterprise";
import ResumeEnterprise from "../components/dashboard/enterprise/dashboard/ResumeEnterprise";
import OpenSecurity from "../components/tools/OpenSecurity";
import OpenChargeWalletEnterprise from "../components/dashboard/enterprise/wallet/OpenChargeWalletEnterprise";
import OpenPin from "../components/tools/OpenPin";
import BankAccountEnterprise from "../components/dashboard/enterprise/wallet/BankAccountEnterprise";
import OpenTransferWalletEnterprise from "../components/dashboard/enterprise/wallet/OpenTransferWalletEnterprise";
import MessageSuportClient from "@/components/dashboard/client/tools/MessageSuportClient";
export default {
  name: "HomeEnterprise",
  components: {
    MessageSuportClient,
    OpenTransferWalletEnterprise,
    BankAccountEnterprise,
    OpenPin,
    OpenChargeWalletEnterprise,
    OpenSecurity,
    ResumeEnterprise,
    DrawerEnterprise,
    Spin,
    Alert,
    "menu-top": MenuTop
  }
};
</script>

<style scoped>
.background {
  background-color: #f5f5f5;
}
</style>
